import { useCallback } from "react";
import { ILesson } from "../models/schedule/lesson";
import { patchComponentSchedule } from "../helpers/utils/calendar.util";
import { useManagedState } from "./useManagedState";

function useSchedulerLessons<T extends ILesson>(initialLessons: T[][] = []) {
  const { currentState, setState, reset, setInitialState } = useManagedState<
    T[][]
  >(initialLessons ?? []);

  const updateLessons = useCallback(
    (lessons: T[][], changedLessons: T[]) => {
      const updatedLessons = patchComponentSchedule(lessons, changedLessons);
      setState(updatedLessons);
    },
    [setState],
  );

  return {
    lessons: currentState,
    updateLessons,
    setLessons: setState,
    reset,
    setInitialLessons: setInitialState,
  };
}

export default useSchedulerLessons;
